import {Hydra} from '../generic/hydra';

import {DossierInterface} from './Dossier';
import {MouvementInterface} from './Mouvement';
import {
    DossierDesistementAdminRequest as DossierDesistementAdminRequestBaseInterface
} from '../../interface/api/DossierDesistementAdminRequest';

export type DossierDesistementAdminRequestInterface = DossierDesistementAdminRequestBaseInterface;

export class DossierDesistementAdminRequest extends Hydra implements DossierDesistementAdminRequestInterface {

    dossier: DossierInterface | string = null;

    mouvement?: MouvementInterface | string | null;

    commentaire?: string = '';

    dateDesistement: string | Date = null;


    constructor(options: DossierDesistementAdminRequestInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
